import type { ItemType } from 'bundles/item/types/ItemType';

// replaces this epic: https://coursera.atlassian.net/browse/GRADE-2850
// https://tools.coursera.org/epic/experiment/VCCR8DMSEeqfVvePAh1ojA
export const enabledGradeVisibilityTypes: ItemType[] = ['staffGraded', 'wiseFlow'];
